<app-slim-topbar></app-slim-topbar>
<div class="layout-content p-0 mb-5 mt-3" [ngClass]="layoutMarginResponsive()">
	<div class="flex align-items-center justify-content-center w-full font-semibold text-2xl my-5">{{'SOFTWARE_LIST' | translate}}</div>
	<div class="grid mt-0 pb-1" [style]="overTablet() ? 'margin-bottom: 28rem;' : ''">
		<div class="col-12" [ngClass]="customPaddingX()">
			<div class="card border-round px-0">
				<!-- INTERCOM SETUP 1.0.0.0 - BETA -->
				<!-- <div class="col-12">
					<div class="flex justify-content-center text-xl font-semibold">INTERCOM SETUP 1.0.0.0 - BETA</div>
				</div> -->
				<div class="col-12" [ngClass]="customPaddingX()">
					<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
						[ngClass]="simpleInputTextLayout('borderRow')">
						<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">INTERCOM SETUP 1.0.0.0 - BETA</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('borderInput')">
							<p-button id="downloadFwPlx3010" label="{{ 'DOWNLOAD_SW' | translate }}" (click)="downloadIntercom10Beta()"
								icon="pi cm-download"
								[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
							</p-button>
						</div>
					</div>
				</div>
				<div class="col-12" [ngClass]="customPaddingX()">
					<p-accordion>
						<p-accordionTab>
							<ng-template pTemplate="header">
								<div class="flex align-items-center w-full"
									[class]="!onExtendedMobile() ? 'flex-row justify-content-between' : 'flex-column justify-content-center'">
									<div class="font-bold" [class]="!onExtendedMobile() ? '' : 'pb-1'">INTERCOM SETUP 1.0.0.0 - BETA | {{'RELEASE_NOTE' | translate}}</div>
								</div>
							</ng-template>
							<div [innerHTML]="getReleaseNoteIntercom10Beta()"></div>
						</p-accordionTab>
					</p-accordion>
				</div>
			</div>
		</div>
		<div class="col-12" [ngClass]="customPaddingX()">
			<div class="card border-round px-0">
				<!-- CAME UPGRADER 2.2.8 -->
				<!-- <div class="col-12">
					<div class="flex justify-content-center text-xl font-semibold">CAME UPGRADER 2.2.8 </div>
				</div> -->
				<div class="col-12" [ngClass]="customPaddingX()">
					<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
						[ngClass]="simpleInputTextLayout('borderRow')">
						<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">CAME UPGRADER 2.2.8</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="simpleInputTextLayout('borderInput')">
							<p-button id="downloadFwXts7Wifi703" label="{{ 'DOWNLOAD_SW' | translate }}" (click)="downloadUpgrader228()"
								icon="pi cm-download"
								[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
							</p-button>
						</div>
					</div>
				</div>
				<div class="col-12" [ngClass]="customPaddingX()">
					<p-accordion>
						<p-accordionTab>
							<ng-template pTemplate="header">
								<div class="flex align-items-center w-full"
									[class]="!onExtendedMobile() ? 'flex-row justify-content-between' : 'flex-column justify-content-center'">
									<div class="font-bold" [class]="!onExtendedMobile() ? '' : 'pb-1'">CAME UPGRADER 2.2.8 | {{'RELEASE_NOTE' | translate}}</div>
								</div>
							</ng-template>
							<div [innerHTML]="getReleaseNoteUpgrader228()"></div>
						</p-accordionTab>
					</p-accordion>
				</div>
			</div>
		</div>
	</div>
</div>
<app-common-footer></app-common-footer>
